<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class=" col-sm-12">
            <div class="">
                <h6 class="f-w-700 pb-1">ProductNumber : {{ compState.productNumber }}</h6>
            </div>
        </div>
        <div class="col-sm-6">
            <label>
                <h6 class="f-w-700">Department</h6>
            </label>
            <select class="form-select" aria-label="Department" v-model="compState.department">
                <option value="" disabled>Department</option>
                <template v-for="department in departmentList" :key="department.id">
                    <option :value="department.name">{{ department.name }}</option>
                </template>
            </select>
        </div>

        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Product Name</h6>
                </label>
                <input v-model="compState.name" class="form-control" type="text" placeholder="Name" maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Barcode</h6>
                </label>
                <input v-model="compState.barcode" class="form-control" type="text" placeholder="Name" maxlength="128">
            </div>
        </div>
        <div class="col-sm-6">

        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Tax Rate</h6>
                </label>
                <select v-model="compState.taxRate" class="form-select" aria-label="Tax Rate">
                    <option value="" disabled>Tax Rate</option>
                    <option value="Tax">Tax</option>
                    <option value="Tax2">Tax2</option>
                    <option value="Tax3">Tax3</option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Service Charge</h6>
                </label>
                <select v-model="compState.serviceCharge" class="form-select" aria-label="Service Charge">
                    <option value="" disabled>Service Charge</option>
                    <option value="ser">Ser</option>
                    <option value="ser2">Ser2</option>
                    <option value="ser3">Ser3</option>
                </select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternative Product Name</h6>
                </label>
                <input v-model="compState.alternateName" class="form-control" type="text" placeholder="Name"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternative Product Name 2</h6>
                </label>
                <input v-model="compState.alternateName2" class="form-control" type="text" placeholder="Name"
                    maxlength="32">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Alternative Display Language</h6>
                </label>
                <input class="form-control" type="text" placeholder="Alternative Display Language"
                    v-model="compState.altLangText" maxlength="32" readonly data-bs-toggle="modal"
                    data-original-title="test" data-bs-target="#alt-lang-modal">
            </div>
        </div>
        <div class="col-sm-6">

        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Display Order</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.displayOrder">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayOrderDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayOrderIncrement">+</button>
            </div>
        </div>
        <div class=" col-sm-6">
            <label>
                <h6 class="f-w-700">Empty Button</h6>
            </label>
            <div class="input-group">
                <input class="form-control" type="number" placeholder="Threshold" v-model="compState.emptyBtn">
                <button class="btn btn-outline-secondary rounded-end-0" type="button"
                    @click="displayOrderDecrement">-</button>
                <button class="btn btn-outline-secondary rounded-start-0" type="button"
                    @click="displayOrderIncrement">+</button>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Single-Item-Select" type="checkbox" value=""
                        v-model="compState.singleItemSale">
                    <label class="form-check-label" for="Single-Item-Select">Single Item Select</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Show-on-Menu" type="checkbox" value=""
                        v-model="compState.showOnMenu">
                    <label class="form-check-label" for="Show-on-Menu">Show on Menu</label>
                </div>
            </div>
        </div>
    </div>
    <productAltLangModal @on-save="onEditAltLang" />
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Product } from '@/store/management/productsStore';

const productAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAltLangModal.vue'))

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
})

const compState = reactive({
    department: '',
    productNumber: '',
    name: '',
    barcode: '',
    taxRate: '',
    serviceCharge: '',
    alternateName: '',
    alternateName2: '',
    displayOrder: 0,
    emptyBtn: 0,
    singleItemSale: false,
    showOnMenu: false,
    altLangText: ''
})

const departmentList = computed(() => {
    return productStore.getDepartmentList
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}
watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const basicData = productGroup.basic
        compState.department = basicData.department
        compState.productNumber = basicData.productNumber
        compState.name = basicData.name
        compState.barcode = basicData.barcode
        compState.taxRate = basicData.taxRate
        compState.serviceCharge = basicData.serviceCharge
        compState.alternateName = basicData.alternateName
        compState.alternateName2 = basicData.alternateName2
        compState.displayOrder = basicData.displayOrder
        compState.singleItemSale = basicData.singleItemSale
        compState.showOnMenu = basicData.showOnMenu
        compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        basic: {
            ...tempActiveProduct.value.basic,
            department: newVal.department,
            productNumber: newVal.productNumber,
            name: newVal.name,
            barcode: newVal.barcode,
            taxRate: newVal.taxRate,
            serviceCharge: newVal.serviceCharge,
            alternateName: newVal.alternateName,
            alternateName2: newVal.alternateName2,
            displayOrder: newVal.displayOrder,
            singleItemSale: newVal.singleItemSale,
            showOnMenu: newVal.showOnMenu
        }
    } as Product)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveProduct.value.basic.altDisplayLang)
}

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>